import React from 'react';

class FormatoSimplificado1347568PlanGamerPlusS_pdf extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
        document.title = 'Red Itmex - Documentacion - Formato Simplificado 1347568 Plan Gamer + SIMÉTRICO';
        this.abrirPdf()
    }
    abrirPdf = () => {
        window.location.href = 'https://firebasestorage.googleapis.com/v0/b/reditmextrescero.appspot.com/o/datasheets%2Flegal%2FITMEX_FORMATO_SIMPLIFICADO_1347568_GAMER%2BS_2024_V1.pdf?alt=media&token=cf8a1790-eaa8-4844-8862-640dd382652c';
    }
    render() {
        return (
            <div>Loading...</div>
        )
    }
}
export default FormatoSimplificado1347568PlanGamerPlusS_pdf